import { RequestService } from '../../../../../common/services/RequestService';
import { GET_REQUEST } from '../constants';

export const getRequestRequest = async payload => {
  const response = await RequestService.get(GET_REQUEST + payload.requestId);
  const profile = response.data.profileId;
  if (profile){
    const user = profile.userId;
    if (user) {
      let phone = user.phone.match(/^(\+7|\+380|\+375)(.*)/);
      if (phone){
        profile.phoneNumber = phone[2];
        profile.phoneCode = phone[1];
      }
      profile.email = user.email ? user.email : 'Не указан';
    }
  }
  return  response
};
